import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "b-plan_table__label__wrapper--disabled"
}
const _hoisted_2 = { class: "h-font-12 h-fw-500 h-opacity-0_5 h-flex h-flex-center" }
const _hoisted_3 = { class: "h-mr-5" }
const _hoisted_4 = { class: "b-reserved-slot-card__title" }
const _hoisted_5 = ["aria-label"]
const _hoisted_6 = {
  key: 0,
  class: "b-reserved-slot-card__tooltip"
}
const _hoisted_7 = { class: "b-reserved-slot-card__tooltip-title" }
const _hoisted_8 = {
  key: 0,
  class: "b-reserved-slot-card__tooltip-line"
}
const _hoisted_9 = {
  ref: "reservedSlotContent",
  class: "b-reserved-slot-card__content"
}
const _hoisted_10 = { class: "b-reserved-slot-card__title" }
const _hoisted_11 = { class: "b-reserved-slot-card__text" }
const _hoisted_12 = {
  key: 0,
  class: "b-reserved-slot-card__type"
}
const _hoisted_13 = {
  key: 0,
  class: "b-plan_table__label--header qa-plan-table-card__time"
}
const _hoisted_14 = { class: "h-bold h-overflow-hidden" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FwIcon = _resolveComponent("FwIcon")!
  const _component_drag = _resolveComponent("drag")!

  return (_ctx.cardData.kind && _ctx.cardData.kind === `room_lunch`)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.cardData.title), 1)
        ])
      ]))
    : (_ctx.cardData.title === `reserved_slot_drive`)
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          style: _normalizeStyle(_ctx.styles),
          class: "b-reserved-slot-card"
        }, [
          _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.$t('CALENDAR.POPUP.RESERVED.SLOT.DRIVE.BACK.TITLE')), 1)
        ], 4))
      : (_ctx.cardData.origin === `from_reserved_slot`)
        ? (_openBlock(), _createElementBlock("div", {
            key: 2,
            ref: "reservedSlotCard",
            style: _normalizeStyle(_ctx.styles),
            class: _normalizeClass(["b-reserved-slot-card", {
        "b-reserved-slot-card--compact": _ctx.eventHeight < 45,
        "b-reserved-slot-card--title-only": _ctx.eventHeight < 28,
        "b-reserved-slot-card--info-open": _ctx.isReservedSlotInfoOpen
    }])
          }, [
            (_ctx.shouldShowReservedSlotInfo)
              ? (_openBlock(), _createElementBlock("span", {
                  key: 0,
                  class: "b-reserved-slot-card__info",
                  "aria-label": _ctx.$t("CALENDAR.POPUP.RESERVED.SLOT.TITLE"),
                  tabindex: "0",
                  onMouseenter: _cache[0] || (_cache[0] = ($event: any) => (_ctx.isReservedSlotInfoOpen = true)),
                  onMouseleave: _cache[1] || (_cache[1] = ($event: any) => (_ctx.isReservedSlotInfoOpen = false)),
                  onFocus: _cache[2] || (_cache[2] = ($event: any) => (_ctx.isReservedSlotInfoOpen = true)),
                  onBlur: _cache[3] || (_cache[3] = ($event: any) => (_ctx.isReservedSlotInfoOpen = false))
                }, [
                  _createVNode(_component_FwIcon, {
                    class: "b-reserved-slot-card__info--icon",
                    icon: "alert-info",
                    size: "12"
                  }),
                  (_ctx.isReservedSlotInfoOpen)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_6, [
                        _createElementVNode("strong", _hoisted_7, _toDisplayString(_ctx.$t('CALENDAR.POPUP.RESERVED.SLOT.TITLE')), 1),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.methods, (method) => {
                          return (_openBlock(), _createElementBlock("span", {
                            key: method,
                            class: "b-reserved-slot-card__tooltip-line"
                          }, _toDisplayString(_ctx.$t(_ctx.methodsMapping[method].text)), 1))
                        }), 128)),
                        (_ctx.cardData.description)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(_ctx.cardData.description), 1))
                          : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true)
                ], 40, _hoisted_5))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.$t('CALENDAR.POPUP.RESERVED.SLOT.TITLE')), 1),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.methods, (method) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: method,
                  class: "b-reserved-slot-card__method"
                }, [
                  _createVNode(_component_FwIcon, {
                    icon: _ctx.methodsMapping[method].icon,
                    size: "10",
                    class: "b-reserved-slot-card__icon"
                  }, null, 8, ["icon"]),
                  _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.$t(_ctx.methodsMapping[method].text)), 1)
                ]))
              }), 128)),
              (_ctx.cardData.description && _ctx.showAppointmentType)
                ? (_openBlock(), _createElementBlock("div", _hoisted_12, _toDisplayString(_ctx.cardData.description), 1))
                : _createCommentVNode("", true)
            ], 512)
          ], 6))
        : (_openBlock(), _createBlock(_component_drag, {
            key: 3,
            class: "drag",
            tag: "div",
            style: _normalizeStyle(_ctx.styles),
            "transfer-data": { card: _ctx.cardData },
            onDragstart: _cache[4] || (_cache[4] = data => _ctx.$emit("dragstart", data)),
            onDragend: _cache[5] || (_cache[5] = data => _ctx.$emit("dragend", data)),
            onDrag: _cache[6] || (_cache[6] = data => _ctx.$emit("drag", data))
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", {
                class: _normalizeClass(["b-plan_table__label__wrapper", {
             "b-plan_table__label__wrapper--drive": _ctx.isDriveEvent,
             "b-plan_table__label__wrapper--small": _ctx.eventHeight <= 15
         }])
              }, [
                _createElementVNode("div", {
                  class: _normalizeClass(["b-plan_table__label", {"b-plan_table__transparent": _ctx.isUnavailabilityEvent }])
                }, [
                  (_ctx.time && !_ctx.isTimeHidden)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_13, _toDisplayString(_ctx.time), 1))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_14, [
                    (_ctx.isUnavailabilityEvent)
                      ? (_openBlock(), _createElementBlock("p", {
                          key: 0,
                          class: _normalizeClass(["h-m-0 b-plan_table__label--small qa-plan-table-card__unavailability-title", {"b-plan_table__label__overflow-text": _ctx.eventHeight <= 70}])
                        }, _toDisplayString(_ctx.$t(_ctx.unavailabilityTitle)), 3))
                      : (_ctx.isDriveEvent)
                        ? (_openBlock(), _createElementBlock("p", {
                            key: 1,
                            class: _normalizeClass(["h-m-0 qa-plan-table-card__unavailability-title", {"b-plan_table__label__overflow-text": _ctx.eventHeight <= 70}])
                          }, " 🚗 " + _toDisplayString(_ctx.$t('EVENT.DRIVE.TITLE')), 3))
                        : (_openBlock(), _createElementBlock("p", {
                            key: 2,
                            class: _normalizeClass(["h-m-0 qa-plan-table-card__title", {"b-plan_table__label__overflow-text": _ctx.eventHeight <= 70}])
                          }, _toDisplayString(_ctx.privateEvent ? _ctx.$t('EVENT.PRIVATE.TITLE') : _ctx.cardData.title), 3))
                  ]),
                  _createElementVNode("div", {
                    style: _normalizeStyle({ background: _ctx.color }),
                    class: "b-plan_table__label__before"
                  }, null, 4),
                  (_ctx.cardData.origin === `from_appointment` && _ctx.cardData.booking_platform !== undefined)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 1,
                        class: _normalizeClass(["b-plan_table__label__appointment", _ctx.accountBookedTypeClass])
                      }, null, 2))
                    : _createCommentVNode("", true)
                ], 2)
              ], 2)
            ]),
            _: 1
          }, 8, ["style", "transfer-data"]))
}